/* COD Form v3 — CodStoreDz layout
   Sends orders to the Google Apps Script (same field names as v2), plus:
   wilaya dropdown + delivery price summary, variants, gallery, sticky bars.
   Everything is inside one IIFE so nothing leaks into (or clashes with) the
   global scope of apps / other theme scripts. */
(function () {
  'use strict';

  var CFG = window.COD_CFG || {};
  var APPS_SCRIPT_URL = CFG.appsScriptUrl || window.APPS_SCRIPT_URL;
  var THANKYOU_URL = CFG.thankyouUrl || window.THANKYOU_URL || '/pages/thankyou';

  var form = document.forms['google-sheet'];
  var btn = document.getElementById('btnSubmitMain');
  if (!form || !btn) return;

  var $ = function (id) { return document.getElementById(id); };
  var phoneInput = $('SaPhone');
  var phoneMsg = $('phoneMessage');
  var wilayaEl = $('Wilaya');
  var btnHTML = btn.innerHTML;

  function fmt(n) {
    // "2 900 دج" — NBSP thousands separator, wrapped in a bidi isolate so the
    // digit groups never swap places inside RTL text.
    var v = Math.round(Number(n) || 0);
    var LRI = String.fromCharCode(0x2066), PDI = String.fromCharCode(0x2069), NBSP = String.fromCharCode(0xA0);
    return LRI + String(v).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP) + PDI + ' دج';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /*********** State ***********/
  var unitPrice = parseFloat(($('SaUnitPrice') || {}).value) || 0;
  var comparePrice = 0;
  var currentQty = 1;
  var currentVariant = null;

  /*********** Auto-fill from URL params (retargeting links) ***********/
  (function autoFillFromURL() {
    try {
      var params = new URLSearchParams(window.location.search);
      var map = {
        name: 'Sa-Name', fname: 'Sa-Name', first_name: 'Sa-Name',
        phone: 'Sa-Phone', tel: 'Sa-Phone',
        wilaya: 'Sa-Wilaya', city: 'Sa-Wilaya',
        address: 'Sa-Address', addr: 'Sa-Address'
      };
      Object.keys(map).forEach(function (key) {
        var val = params.get(key);
        var el = form.elements[map[key]];
        if (!val || !el || el.value) return;
        if (el.tagName === 'SELECT') {
          for (var i = 0; i < el.options.length; i++) {
            if (el.options[i].value === val) { el.value = val; break; }
          }
        } else {
          el.value = val;
        }
      });
    } catch (e) {}
  })();

  /*********** Enter jumps to the next field ***********/
  (function smartFormFlow() {
    var inputs = form.querySelectorAll('input:not([type=hidden]):not([type=radio]):not([tabindex="-1"]), select');
    Array.prototype.forEach.call(inputs, function (el, idx) {
      el.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        var next = inputs[idx + 1];
        if (next) next.focus(); else btn.focus();
      });
    });
  })();

  /*********** Prices + special offers ***********/
  // An offer = pieces received (data-qty), pieces paid (data-paid) and an
  // optional fixed total (data-price, 0 = paid × current unit price).
  var currentOffer = null;
  function offerTotal(r) {
    var fixed = parseFloat(r.getAttribute('data-price')) || 0;
    return fixed > 0 ? fixed : unitPrice * (parseFloat(r.getAttribute('data-paid')) || 1);
  }
  function productTotal() {
    return currentOffer ? offerTotal(currentOffer) : unitPrice * currentQty;
  }

  function renderPrices() {
    var total = productTotal();
    $('SaUnitPrice').value = unitPrice;
    $('SaPrice').value = unitPrice;
    $('SaTotal').value = total;

    document.querySelectorAll('[data-cod-price]').forEach(function (el) { el.textContent = fmt(unitPrice); });
    var save = comparePrice > unitPrice ? comparePrice - unitPrice : 0;
    document.querySelectorAll('[data-cod-old-price]').forEach(function (el) {
      el.hidden = !save; el.textContent = fmt(comparePrice);
    });
    document.querySelectorAll('[data-cod-save]').forEach(function (el) {
      el.hidden = !save; el.textContent = 'وفّر ' + fmt(save);
    });
    // Offer prices follow the selected variant's price
    form.querySelectorAll('input[name="Sa-Offer"]').forEach(function (r) {
      var row = r.closest('.offer-row');
      var t = offerTotal(r);
      var full = unitPrice * (parseFloat(r.getAttribute('data-qty')) || 1);
      var p = row.querySelector('[data-offer-price]');
      var o = row.querySelector('[data-offer-old]');
      if (p) p.textContent = fmt(t);
      if (o) { o.hidden = !(full > t); o.textContent = fmt(full); }
      row.classList.toggle('selected', r.checked);
    });
    var sticky = document.querySelector('.sticky-price');
    if (sticky) sticky.textContent = fmt(total);
  }

  /*********** Quantity: offers when enabled, otherwise the − / + stepper ***********/
  function setQty(n) {
    currentQty = Math.max(1, Math.min(20, n));
    if ($('qtyVal')) $('qtyVal').textContent = currentQty;
    $('hiddenQty').value = currentQty;
    $('hiddenOffer').value = currentQty;
    renderPrices();
  }
  document.querySelectorAll('[data-qty-action]').forEach(function (b) {
    b.addEventListener('click', function () {
      setQty(currentQty + (b.getAttribute('data-qty-action') === 'inc' ? 1 : -1));
    });
  });
  function applyOffer() {
    currentOffer = form.querySelector('input[name="Sa-Offer"]:checked');
    if (currentOffer) setQty(parseInt(currentOffer.getAttribute('data-qty'), 10) || 1);
    else renderPrices();
  }
  form.querySelectorAll('input[name="Sa-Offer"]').forEach(function (r) {
    r.addEventListener('change', applyOffer);
  });

  /*********** Gallery (native scroll-snap swipe + thumbs + arrows) ***********/
  var slider = $('codSlider');
  var slides = slider ? slider.querySelectorAll('.cod-slide') : [];
  var activeSlide = 0;
  function goToSlide(i) {
    if (!slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    // offsetLeft works in both LTR and RTL; scrollLeft sign differs in RTL, so
    // scroll the slide into view horizontally only (never jumps the page).
    var target = slides[i];
    var sRect = slider.getBoundingClientRect();
    var tRect = target.getBoundingClientRect();
    slider.scrollBy({ left: tRect.left - sRect.left, behavior: 'smooth' });
  }
  function markSlide(i) {
    activeSlide = i;
    var count = $('codCount');
    if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    document.querySelectorAll('.cod-thumb').forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
  }
  if (slider && slides.length > 1) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) markSlide(Number(en.target.getAttribute('data-index')) || 0);
        });
      }, { root: slider, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
    document.querySelectorAll('.cod-thumb').forEach(function (t) {
      t.addEventListener('click', function () { goToSlide(Number(t.getAttribute('data-index')) || 0); });
    });
    document.querySelectorAll('[data-cod-nav]').forEach(function (b) {
      b.addEventListener('click', function () { goToSlide(activeSlide + Number(b.getAttribute('data-cod-nav'))); });
    });
    // Pause any playing video when it is swiped away
    slider.addEventListener('scroll', function () {
      slider.querySelectorAll('video').forEach(function (v) { if (!v.paused) v.pause(); });
    }, { passive: true });
  }
  function goToMedia(mediaId) {
    if (!mediaId || !slider) return;
    var s = slider.querySelector('.cod-slide[data-media-id="' + mediaId + '"]');
    if (s) goToSlide(Number(s.getAttribute('data-index')) || 0);
  }

  /*********** Variants ***********/
  var variants = [];
  try { variants = JSON.parse(($('codVariants') || {}).textContent || '[]'); } catch (e) {}
  function selectedOptions() {
    var out = [];
    form.querySelectorAll('input[type=radio][data-option-index]:checked').forEach(function (r) {
      out[Number(r.getAttribute('data-option-index'))] = r.value;
    });
    return out;
  }
  function updateVariant(fromUser) {
    if (!variants.length) return;
    var opts = selectedOptions();
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var k = 0; k < opts.length; k++) { if (opts[k] != null && variants[i].options[k] !== opts[k]) { ok = false; break; } }
      if (ok) { v = variants[i]; break; }
    }
    opts.forEach(function (val, k) {
      var lbl = form.querySelector('[data-option-label="' + k + '"]');
      if (lbl) lbl.textContent = val;
    });
    currentVariant = v;
    $('SaVariant').value = v ? v.title : opts.join(' / ');
    $('SaVariantId').value = v ? v.id : '';
    if (v) { unitPrice = v.price; comparePrice = v.compare; }
    var soldOut = !v || !v.available;
    btn.disabled = soldOut || formSubmitted;
    btn.classList.toggle('is-soldout', soldOut);
    if (!formSubmitted) btn.innerHTML = soldOut ? '<span class="btn-text"><span>' + (v ? 'نفذ هذا الخيار — اختر خياراً آخر' : 'هذا الخيار غير متوفر') + '</span></span>' : btnHTML;
    renderPrices();
    if (fromUser && v && v.media) goToMedia(v.media);
  }
  if (variants.length) {
    var first = variants.filter(function (v) { return String(v.id) === String($('SaVariantId').value); })[0];
    if (first) { comparePrice = first.compare; currentVariant = first; }
    form.querySelectorAll('input[type=radio][data-option-index]').forEach(function (r) {
      r.addEventListener('change', function () { updateVariant(true); });
    });
    // Grey out option values that have no available variant at all
    form.querySelectorAll('input[type=radio][data-option-index]').forEach(function (r) {
      var k = Number(r.getAttribute('data-option-index'));
      var any = variants.some(function (v) { return v.available && v.options[k] === r.value; });
      if (!any) r.closest('label').classList.add('is-soldout');
    });
    updateVariant(false);
  } else {
    var oldEl = document.querySelector('[data-cod-old-price]');
    if (oldEl && !oldEl.hidden) comparePrice = parseFloat(oldEl.textContent.replace(/[^\d]/g, '')) || 0;
  }
  applyOffer();
  if (wilayaEl) wilayaEl.addEventListener('change', function () {
    wilayaEl.classList.toggle('is-invalid', !wilayaEl.value);
  });

  /*********** Phone — Algerian validation ***********/
  function extractDigits(str) {
    // Arabic-Indic / Persian digits → ASCII (common on Arabic keyboards)
    var d = String(str || '').replace(/[٠-٩]/g, function (c) { return c.charCodeAt(0) - 0x660; })
      .replace(/[۰-۹]/g, function (c) { return c.charCodeAt(0) - 0x6F0; })
      .replace(/\D/g, '');
    if (d.indexOf('00213') === 0) d = d.substring(5);
    else if (d.indexOf('213') === 0 && d.length >= 11) d = d.substring(3);
    if (d.length === 9 && /^[567]/.test(d)) d = '0' + d;
    return d;
  }
  function isValidAlgerianPhone(d) { return /^0[567]\d{8}$/.test(d); }
  function showPhoneMsg(text, ok) {
    if (!phoneMsg) return;
    phoneMsg.textContent = text;
    phoneMsg.classList.toggle('is-show', !!text);
    phoneMsg.classList.toggle('is-ok', !!ok);
  }
  function updatePhoneUI(strict) {
    var digits = extractDigits(phoneInput.value);
    $('SaPhoneDigits').value = digits;
    phoneInput.classList.remove('is-valid', 'is-invalid');
    if (!digits.length) { showPhoneMsg(strict ? '⚠️ أدخل رقم هاتفك ليتصل بك فريقنا' : ''); if (strict) phoneInput.classList.add('is-invalid'); return; }
    if (isValidAlgerianPhone(digits)) {
      phoneInput.classList.add('is-valid');
      showPhoneMsg('✓ رقم صحيح', true);
    } else if (digits.length < 10 && !strict) {
      showPhoneMsg('');
    } else {
      phoneInput.classList.add('is-invalid');
      showPhoneMsg(digits.length < 10 ? '⚠️ الرقم ناقص — يجب أن يكون 10 أرقام' : '⚠️ رقم غير صحيح — يبدأ بـ 05 أو 06 أو 07 ويتكوّن من 10 أرقام');
    }
  }
  function hasPhoneForSending() {
    var digits = extractDigits(phoneInput.value);
    $('SaPhoneDigits').value = digits;
    return isValidAlgerianPhone(digits);
  }
  phoneInput.addEventListener('input', function () { updatePhoneUI(false); });
  phoneInput.addEventListener('blur', function () { if (phoneInput.value.trim()) updatePhoneUI(true); });

  /*********** IDs ***********/
  function safeUUID() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'id_' + Math.random().toString(36).slice(2) + '_' + Date.now().toString(36);
  }
  var SESSION_ID = (function () {
    try {
      var sid = sessionStorage.getItem('sa_session_id_v1');
      if (!sid) { sid = safeUUID(); sessionStorage.setItem('sa_session_id_v1', sid); }
      return sid;
    } catch (e) { return safeUUID(); }
  })();
  $('saSessionId').value = SESSION_ID;

  /*********** Date + page URL + GCLID/WBRAID/GBRAID (offline conversions) ***********/
  (function initDateTimeAndSource() {
    var p = function (n) { return String(n).padStart(2, '0'); };
    var now = new Date();
    $('datetime').value = now.getFullYear() + '-' + p(now.getMonth() + 1) + '-' + p(now.getDate()) + ' ' + p(now.getHours()) + ':' + p(now.getMinutes()) + ':' + p(now.getSeconds());
    $('campaignUrl').value = window.location.href;
    var params = new URLSearchParams(window.location.search || '');
    var gclid = params.get('gclid') || params.get('gclid_aw') || params.get('gcl_aw') || '';
    if (!gclid) gclid = params.get('wbraid') || params.get('gbraid') || '';
    $('gclid').value = gclid;
  })();

  /*********** Behaviour metrics (sent to the sheet only) ***********/
  var pageLoadTime = Date.now();
  var lastInteraction = Date.now();
  var mouseMoveCount = 0, mouseTotalDistance = 0, lastMouseX = null, lastMouseY = null;
  var scrollCount = 0, scrollTotalDistance = 0, scrollMaxDepth = 0;
  var lastScrollY = window.scrollY || 0, lastScrollTime = Date.now(), scrollLongestPause = 0;
  var focusCount = 1;

  var ua = (navigator.userAgent || '').toLowerCase();
  var viewportW = window.innerWidth || document.documentElement.clientWidth;
  var viewportH = window.innerHeight || document.documentElement.clientHeight;
  var deviceType = (/mobile|android|iphone|ipod/.test(ua) || viewportW <= 768) ? 'mobile'
    : ((/ipad|tablet/.test(ua) || viewportW <= 1024) ? 'tablet' : 'desktop');
  var networkType = (navigator.connection && navigator.connection.effectiveType) || '';

  ['input', 'change', 'click', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function () { lastInteraction = Date.now(); }, { capture: true, passive: true });
  });
  document.addEventListener('mousemove', function (e) {
    mouseMoveCount++;
    if (lastMouseX !== null) mouseTotalDistance += Math.sqrt(Math.pow(e.clientX - lastMouseX, 2) + Math.pow(e.clientY - lastMouseY, 2));
    lastMouseX = e.clientX; lastMouseY = e.clientY;
    lastInteraction = Date.now();
  }, { passive: true });
  window.addEventListener('scroll', function () {
    scrollCount++;
    lastInteraction = Date.now();
    var y = window.scrollY || 0;
    var max = document.documentElement.scrollHeight - viewportH;
    if (max > 0 && y / max > scrollMaxDepth) scrollMaxDepth = y / max;
    var now = Date.now();
    if (now - lastScrollTime > scrollLongestPause) scrollLongestPause = now - lastScrollTime;
    lastScrollTime = now;
    scrollTotalDistance += Math.abs(y - lastScrollY);
    lastScrollY = y;
  }, { passive: true });

  function getBehaviorMetrics() {
    return {
      'Sa-Time-Stay': String(Math.round((Date.now() - pageLoadTime) / 1000)),
      'Sa-Mouse-Move-Count': String(mouseMoveCount),
      'Sa-Mouse-Total-Distance': String(Math.round(mouseTotalDistance)),
      'Sa-Scroll-Count': String(scrollCount),
      'Sa-Scroll-Total-Distance': String(scrollTotalDistance),
      'Sa-Scroll-Max-Depth': scrollMaxDepth.toFixed(2),
      'Sa-Scroll-Longest-Pause': String(scrollLongestPause),
      'Sa-Scroll-Avg-Speed': String(scrollCount ? Math.round(scrollTotalDistance / scrollCount) : 0),
      'Sa-Device-Type': deviceType,
      'Sa-Viewport-W': String(viewportW),
      'Sa-Viewport-H': String(viewportH),
      'Sa-Screen-W': String((window.screen && screen.width) || viewportW),
      'Sa-Screen-H': String((window.screen && screen.height) || viewportH),
      'Sa-DPR': String(window.devicePixelRatio || 1),
      'Sa-Browser-Lang': navigator.language || '',
      'Sa-User-Agent': navigator.userAgent || '',
      'Sa-Network-Type': networkType,
      'Sa-Focus-Count': String(focusCount)
    };
  }

  /*********** FormData ***********/
  function buildFD(stage) {
    renderPrices();
    var fd = new FormData(form);
    fd.set('Sa-Lead-Stage', stage);
    $('leadStage').value = stage;
    var eventId = safeUUID();
    fd.set('Sa-Session-Id', SESSION_ID);
    fd.set('Sa-Event-Id', eventId);
    $('saEventId').value = eventId;
    fd.set('Sa-Phone-Digits', extractDigits(phoneInput.value));
    fd.set('Quantity', String(currentQty));
    fd.set('Offer', String(currentQty));
    var metrics = getBehaviorMetrics();
    Object.keys(metrics).forEach(function (k) { fd.set(k, metrics[k]); });
    $('timeStay').value = metrics['Sa-Time-Stay'];
    fd.set('Sa-Client-ISOTime', new Date().toISOString());
    fd.delete('Sa-Bot-Trap');
    return fd;
  }
  function fdToURLEncoded(fd) {
    var params = new URLSearchParams();
    fd.forEach(function (v, k) { params.append(k, v); });
    return params.toString();
  }

  /*********** Background sends (Draft / Attempted / Abandoned) ***********/
  function sendViaBeaconOrKeepalive(fd) {
    try {
      var body = fdToURLEncoded(fd);
      if (navigator.sendBeacon) {
        if (navigator.sendBeacon(APPS_SCRIPT_URL, new Blob([body], { type: 'application/x-www-form-urlencoded' }))) return true;
      }
      fetch(APPS_SCRIPT_URL, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body, keepalive: true }).catch(function () {});
      return true;
    } catch (e) { return false; }
  }

  /*********** Retry queue for failed orders ***********/
  var QKEY = 'sa_failed_queue_v1';
  function getQueue() { try { var q = JSON.parse(localStorage.getItem(QKEY) || '[]'); return Array.isArray(q) ? q : []; } catch (e) { return []; } }
  function setQueue(q) { try { localStorage.setItem(QKEY, JSON.stringify(q)); } catch (e) {} }
  function queueFD(fd) {
    var obj = {};
    fd.forEach(function (v, k) { obj[k] = v; });
    obj.__queuedAt = Date.now();
    var q = getQueue();
    q.push(obj);
    setQueue(q.slice(-20));
  }
  var retryInProgress = false;
  function retryQueue(max) {
    if (retryInProgress) return;
    var q = getQueue();
    if (!q.length) return;
    retryInProgress = true;
    var delivered = [];
    var chain = Promise.resolve();
    q.forEach(function (item, i) {
      chain = chain.then(function () {
        if (i >= max) return;
        var params = new URLSearchParams();
        Object.keys(item).forEach(function (k) { if (k !== '__queuedAt') params.append(k, item[k]); });
        return fetch(APPS_SCRIPT_URL, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: params.toString() })
          .then(function (res) { if (res && res.ok) delivered.push(item['Sa-Event-Id']); })
          .catch(function () {});
      });
    });
    chain.then(function () {
      setQueue(getQueue().filter(function (item) { return !delivered.includes(item['Sa-Event-Id']); }));
    }).finally(function () { retryInProgress = false; });
  }
  window.addEventListener('online', function () { retryQueue(10); });

  function submitWithRetry(fd, attempt) {
    attempt = attempt || 0;
    return fetch(APPS_SCRIPT_URL, { method: 'POST', body: fd })
      .then(function (res) { if (!res || !res.ok) throw new Error('Server error'); return true; })
      .catch(function (err) {
        if (attempt < 3) {
          return new Promise(function (resolve) { setTimeout(function () { resolve(submitWithRetry(fd, attempt + 1)); }, 1500); });
        }
        queueFD(fd);
        throw err;
      });
  }

  /*********** Thank-you redirect ***********/
  function redirectToThankYou() {
    // Customer details go through sessionStorage, NOT the URL: a name/phone in
    // the query string ends up in analytics + ad pixels (Meta flags that as
    // personal data), in the browser history and in shared links.
    var order = {
      name: (form.elements['Sa-Name'] || {}).value || '',
      phone: $('SaPhoneDigits').value,
      wilaya: wilayaEl ? wilayaEl.value : '',
      product: CFG.productTitle || '',
      variant: currentVariant && currentVariant.title !== 'Default Title' ? currentVariant.title : '',
      offer: currentOffer ? currentOffer.value : '',
      qty: currentQty,
      total: $('SaTotal').value
    };
    try { sessionStorage.setItem('cod_last_order', JSON.stringify(order)); } catch (e) {}
    var qs = 'q=' + encodeURIComponent(order.qty) + '&t=' + encodeURIComponent(order.total);
    window.location.href = THANKYOU_URL + (THANKYOU_URL.indexOf('?') === -1 ? '?' : '&') + qs;
  }

  var formSubmitted = false, abandonedSent = false, lastDraftHash = '', lastAttemptHash = '';
  function draftHash() {
    return [extractDigits(phoneInput.value), (form.elements['Sa-Name'].value || '').trim(),
      wilayaEl ? wilayaEl.value : '', (form.elements['Sa-Address'].value || '').trim(),
      currentQty, $('SaVariantId').value].join('|');
  }
  function sendAttemptedIfNeeded() {
    if (document.visibilityState === 'hidden' || formSubmitted || !hasPhoneForSending()) return;
    var h = draftHash();
    if (h === lastAttemptHash) return;
    lastAttemptHash = h;
    sendViaBeaconOrKeepalive(buildFD('Attempted'));
  }
  function sendAbandonedLead() {
    if (formSubmitted || abandonedSent || !hasPhoneForSending()) return;
    sendViaBeaconOrKeepalive(buildFD('Abandoned'));
    abandonedSent = true;
  }
  function sendDraftSnapshot() {
    if (document.visibilityState === 'hidden' || formSubmitted || !hasPhoneForSending()) return;
    var h = draftHash();
    if (h === lastDraftHash) return;
    lastDraftHash = h;
    sendViaBeaconOrKeepalive(buildFD('Draft'));
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') focusCount++; else sendAbandonedLead();
  });
  window.addEventListener('pagehide', sendAbandonedLead);
  setInterval(function () {
    if (!formSubmitted && hasPhoneForSending() && Date.now() - lastInteraction > 120000) sendAbandonedLead();
  }, 30000);
  setInterval(sendDraftSnapshot, 25000);

  /*********** Submit ***********/
  function fail(el, msg) {
    if (el) { el.classList.add('is-invalid'); el.focus(); el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    if (msg && el === phoneInput) showPhoneMsg(msg);
    sendAttemptedIfNeeded();
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (formSubmitted || btn.disabled) return;

    var trap = $('Sa-Bot-Trap');
    if (trap && trap.value) return; // bot

    // A real person needs a few seconds to fill the form. If a (very fast,
    // autofilled) submit comes earlier, wait instead of silently dropping it.
    var elapsed = Date.now() - pageLoadTime;
    if (elapsed < 3000) { setTimeout(function () { form.requestSubmit ? form.requestSubmit() : btn.click(); }, 3000 - elapsed); return; }

    var nameEl = form.elements['Sa-Name'];
    if (!nameEl.value.trim()) return fail(nameEl);
    nameEl.classList.remove('is-invalid');
    if (!hasPhoneForSending()) { updatePhoneUI(true); return fail(phoneInput); }
    if (wilayaEl && !wilayaEl.value) return fail(wilayaEl);

    formSubmitted = true;
    var submittedFD = buildFD('Submitted');
    var orderControls = form.querySelectorAll('input, select, button');
    var previousDisabled = Array.from(orderControls, function (el) { return el.disabled; });
    orderControls.forEach(function (el) { el.disabled = true; });
    btn.disabled = true;
    btn.innerHTML = '<span class="cod-spinner" aria-hidden="true"></span><span>جاري إرسال طلبيتك...</span>';
    $('formNetworkError').style.display = 'none';

    submitWithRetry(submittedFD)
      .then(function () {
        // An earlier failed attempt of this same order may still be queued for
        // retry — drop it, or it would be sent again later as a duplicate.
        var phone = $('SaPhoneDigits').value;
        setQueue(getQueue().filter(function (it) { return it['Sa-Phone-Digits'] !== phone; }));
        btn.innerHTML = '<span>✅ تم إرسال طلبك</span>';
        redirectToThankYou();
      })
      .catch(function () {
        formSubmitted = false;
        orderControls.forEach(function (el, i) { el.disabled = previousDisabled[i]; });
        btn.disabled = false;
        btn.innerHTML = btnHTML;
        $('formNetworkError').style.display = 'block';
      });
  });

  /*********** Sticky bars ***********/
  var orderSection = $('orderSection');
  var stickyBar = $('stickyBar');
  function scrollToForm() {
    if (orderSection) orderSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(function () { var n = form.elements['Sa-Name']; if (n && !n.value) n.focus({ preventScroll: true }); }, 600);
  }
  window.scrollToForm = scrollToForm;
  document.querySelectorAll('[data-scroll-to-form]').forEach(function (b) { b.addEventListener('click', scrollToForm); });

  if ('IntersectionObserver' in window) {
    // Bottom bar: only while the form is off-screen
    if (orderSection && stickyBar) {
      new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(orderSection);
    }
    // Top title+price bar: once the price has scrolled away
    var head = $('codStickyHead');
    var priceBlock = $('codPriceBlock');
    if (head && priceBlock) {
      new IntersectionObserver(function (entries) {
        var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        head.classList.toggle('is-visible', hidden);
      }, { threshold: 0 }).observe(priceBlock);
    }
  }

  window.addEventListener('load', function () { retryQueue(10); });
})();
